/* =====================================================================
   UNNWRAP — B2B PAGE: SCROLL FADE-IN ANIMATION
   =====================================================================
   What this does:
   Every element with the class "fade-in" starts invisible and slightly
   lower than its final position (see .fade-in in b2b-page.css). As soon
   as that element scrolls into view, we add the class "is-visible",
   which triggers a CSS transition that fades it in and slides it up.

   How it works, step by step:
   1. Find every element with the "fade-in" class, but only inside our
      page wrapper (so we never touch other sections of the theme).
   2. Create an IntersectionObserver — a built-in browser tool that
      watches elements and tells us when they enter the visible area
      of the screen (the "viewport").
   3. When an element becomes visible, add "is-visible" to it and stop
      watching it (we only need to animate it once).
   4. Older browsers that don't support IntersectionObserver just show
      everything immediately, no animation — this keeps the page usable
      everywhere.
   ===================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  var fadeElements = document.querySelectorAll('.b2b-page .fade-in');

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          // Once it's faded in, we don't need to watch it any more.
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 }); // fire when ~12% of the element is on screen

    fadeElements.forEach(function (el) {
      observer.observe(el);
    });
  } else {
    // Fallback for very old browsers: just show everything, no animation.
    fadeElements.forEach(function (el) {
      el.classList.add('is-visible');
    });
  }
});
